export enum Mime {
  UNKNOWN_FILE,
  PDF = 'application/pdf',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
}